import { ApprovalProcessAdd, IApprovalProcess, IApprovalProcessDetail } from 'src/types/helpdesk/approvalProcess.type';
import { PagedList } from 'src/types/pagedList.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/approval-processes';

export const getApprovalProcesses = async (
  sequenceStatus: string,
  page: number,
  pageSize: number,
  orderBy?: string,
  positionId?: number,
  employeeId?: number,
  departmentId?: number,
  templateId?: number,
  ticketRefId?: number,
  isHelpDesk?: boolean
) =>
  await http.get<PagedList<IApprovalProcess>>(controller, {
    params: {
      sequenceStatus,
      page,
      pageSize,
      orderBy,
      positionId,
      employeeId,
      departmentId,
      ticketRefId,
      templateId,
      isHelpDesk
    }
  });

export const getApprovalProcess = async (id: number) => await http.get<IApprovalProcess>(`${controller}/${id}`);

export const getApprovalProcessDetail = async (id: number, approvalVersion: number, createdBy: number) =>
  await http.get<IApprovalProcessDetail[]>(`${controller}/get-detail-by-created`, {
    params: {
      id,
      approvalVersion,
      createdBy
    }
  });

export const getApprovalProcessDetailByCreated = async (id: number, approvalVersion: number, createdBy: number) =>
  await http.get<IApprovalProcessDetail[]>(`${controller}/get-detail-by-created`, {
    params: {
      id,
      approvalVersion,
      createdBy
    }
  });

export const getApprovalProcessByCondition = async (id?: number, version?: number) =>
  await http.get<IApprovalProcess>(`${controller}/${id}/version/${version}`);

export const addApprovalProcess = async (approvalProcess: ApprovalProcessAdd) =>
  await http.post(controller, approvalProcess);

export const updateApprovalProcess = async (id: number, approvalProcess: IApprovalProcess) =>
  await http.put(`${controller}/${id}`, approvalProcess);

export const deleteApprovalProcess = async (id: number) => await http.delete(`${controller}/${id}`);
